import React, { useEffect, useState } from 'react';
import { Form, Input, Collapse, Button, Space, InputNumber, Select, Checkbox } from 'antd';
import { FaTrash } from '@react-icons/all-files/fa/FaTrash'
import { MONTHS_OPTIONS, YEARS_OPTIONS } from '../../constants';
const { Panel } = Collapse;
export default props => {
    const { form } = props;
    return (
        <>
            <div className="description">
                Highlight your key professional experiences from the past decade. Utilize bullet points to showcase specific accomplishments, preferably with quantifiable results (e.g., 'Increased efficiency by 20% through implementation of new processes').
            </div>
            <Form.List name="experience">
                {(fields, { add, remove }) => (
                    <>
                        {fields.map(({ key, name, fieldKey, ...restField }) => {
                            let currentObj = form.getFieldValue('experience')
                            currentObj = currentObj[key]

                            const experienceName = currentObj?.jobPosition || currentObj?.companyName || `Experience ${name + 1}`;
                            return (
                                <Collapse className="skills-collapse" key={key}>
                                    <Panel key={key} align="baseline" className="skill-item" header={(<div className="skill-item-header">
                                        <div className="left">
                                            {experienceName}
                                        </div>
                                        <div className="right" >
                                            <FaTrash onClick={() => remove(name)} style={{ cursor: 'pointer' }} />
                                        </div>
                                    </div>)}>
                                        <Form.Item {...restField} name={[name, 'companyName']} label="Company Name">
                                            <Input placeholder="Enter company name" />
                                        </Form.Item>
                                        <Form.Item {...restField} name={[name, 'jobPosition']} label="Job Position">
                                            <Input placeholder="Enter job position" />
                                        </Form.Item>
                                        <Form.Item {...restField} name={[name, 'description']} label="Description">
                                            <Input.TextArea rows={2} placeholder="Enter job description" />
                                        </Form.Item>
                                        <div className="row">
                                            {/* Start Date */}
                                            <Form.Item label="Start Date" className="start-date">
                                                <div className="row">
                                                    <Form.Item {...restField} name={[name, 'startDate', 'month']} >
                                                        <Select placeholder="Month" options={MONTHS_OPTIONS} />
                                                    </Form.Item>
                                                    <Form.Item {...restField} name={[name, 'startDate', 'year']}>
                                                        <Select placeholder="Year" options={YEARS_OPTIONS} />
                                                    </Form.Item>
                                                </div>
                                            </Form.Item>

                                            {/* End Date */}
                                            <Form.Item label="End Date" className="end-date">
                                                <div className="row">
                                                    <Form.Item {...restField} name={[name, 'endDate', 'month']} >
                                                        <Select placeholder="Month" options={MONTHS_OPTIONS} disabled={currentObj?.isPresent} />
                                                    </Form.Item>
                                                    <Form.Item {...restField} name={[name, 'endDate', 'year']} >
                                                        <Select placeholder="Year" options={YEARS_OPTIONS} disabled={currentObj?.isPresent} />
                                                    </Form.Item>
                                                </div>
                                                <Form.Item {...restField} name={[name, 'isPresent']} valuePropName="checked">
                                                    <Checkbox >I still work here</Checkbox>
                                                </Form.Item>


                                            </Form.Item>
                                        </div>
                                    </Panel>
                                </Collapse>
                            )
                        }
                        )}
                        <Button type="dashed" onClick={() => add()} block>
                            Add Experience
                        </Button>
                    </>
                )}
            </Form.List>
        </>

    )
}